import {
  AUTH_ERROR,
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  REGISTER_FAIL,
  REGISTER_SUCCESS,
  USER_LOADED,
  USER_LOADING,
  UPDATE_FARM,
  UPDATE_USER,
} from "../actions/actionTypes";

const token_ = localStorage.getItem("token");
const usertype = localStorage.getItem("usertype");
const initialState = {
  token: token_,
  isAuthenticated: token_ ? true : null,
  usertype,
  user: null,
  isLoading: false,
};

export default function auth(state = initialState, action) {
  switch (action.type) {
    case USER_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case USER_LOADED:
      localStorage.setItem("usertype", action.payload.usertype);
      return {
        ...state,
        isLoading: false,
        isAuthenticated: true,
        usertype: action.payload.usertype,
        user: action.payload,
      };
    case UPDATE_USER:
      return {
        ...state,
        user: {
          ...action.payload,
          farm: state.user.farm,
        },
      };
    case LOGIN_SUCCESS:
    case REGISTER_SUCCESS:
      localStorage.setItem("token", action.payload.token);
      localStorage.setItem("usertype", action.payload.user?.usertype);
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isAuthenticated: true,
      };
    case UPDATE_FARM:
      return {
        ...state,
        user: {
          ...state.user,
          farm: {
            ...state.user?.farm,
            ...action.payload,
          },
        },
      };
    case AUTH_ERROR:
    case LOGIN_FAIL:
    case REGISTER_FAIL:
    case LOGOUT_SUCCESS:
      localStorage.removeItem("token");
      localStorage.removeItem("usertype");
      return {
        ...initialState,
        token: null,
        isAuthenticated: false,
        usertype: null,
      };
    default:
      return state;
  }
}
